import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'

export const completeAuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  if (authService.isAuthenticated()) {
    return true
  }

  // Check if user has incomplete 2FA setup
  const tempToken = sessionStorage.getItem('temp_access_token')
  const tempUserData = sessionStorage.getItem('temp_user_data')

  if (tempToken && tempUserData) {
    try {
      const userData = JSON.parse(tempUserData)
      if (!userData.two_factor_enabled) {
        return router.createUrlTree(['/auth/2fa-setup-mandatory'], {
          queryParams: { returnUrl: state.url },
        })
      }
    } catch (error) {
      console.error('Error parsing temp user data:', error)
    }
  }

  return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } })
}
